// extracted by mini-css-extract-plugin
export default {"resizeDiv":"scheduledJobs_resizeDiv__jCTcf","resizeBorder":"scheduledJobs_resizeBorder__cBP61"};